/* eslint-disable strict */
module.exports = /*@ngInject*/ function DevicePropertyVisibility() {
    return function (devices, devicePropertyVisibilityConfigurations) {
        return devices.map(device => {
            var currentDeviceConfiguration = devicePropertyVisibilityConfigurations && devicePropertyVisibilityConfigurations.find(config => {
                return config.type === device.type
            })
            var hiddenProperties = currentDeviceConfiguration ? currentDeviceConfiguration.hiddenProperties : [];
            device.viewProperties = `<div style='width: 300px;'>`;
            if (!(hiddenProperties && hiddenProperties.find(hiddenProperty => hiddenProperty === 'hostname'))) {
                device.viewProperties += `<p> <b>Zabbix Host: </b>${device && device.hostname}</p>`
            }
            if (!(hiddenProperties && hiddenProperties.find(hiddenProperty => hiddenProperty === 'ipAddr'))) {
                device.viewProperties += `<p> <b>IP Address: </b>${device && device.ipAddr}</p>`
            }
            if (!(hiddenProperties && hiddenProperties.find(hiddenProperty => hiddenProperty === 'serial'))) {
                device.viewProperties += `<p> <b>Serial: </b>${device &&  device.serial}</p>`
            }
            if (!(hiddenProperties && hiddenProperties.find(hiddenProperty => hiddenProperty === 'config'))) {
                device.viewProperties += `<p> <b>Config: </b>${device && device.config}</p>`
            }
            if (!(hiddenProperties && hiddenProperties.find(hiddenProperty => hiddenProperty === 'firmware'))) {
                device.viewProperties += `<p> <b>Firmware: </b>${device && device.firmware}</p>`
            }
            if (!(hiddenProperties && hiddenProperties.find(hiddenProperty => hiddenProperty === 'type'))) {
                device.viewProperties += `<p> <b>Type: </b>${device && device.type}</p>`
            }  
            if (!(hiddenProperties && hiddenProperties.find(hiddenProperty => hiddenProperty === 'paintedCoachId'))) {
                device.viewProperties += `<p> <b>Painted Coach ID: </b>${device && device.paintedCoachId}</p>`
            }
            if (!(hiddenProperties && hiddenProperties.find(hiddenProperty => hiddenProperty === 'position'))) {
                device.viewProperties += `<p> <b>Position: </b>${device && device.position}</p>`
            }
            device.viewProperties += `</div>`;
            return device
        })
    }
};